<template>
    <div>
        <compWrapper title="基本信息" theme="primary">
            <compFormQuery v-if="type=='query'" class="margin-top-15 margin-right-15" :formdata="getBase" :value="formData" :labelWidth="120"></compFormQuery>
            <compFormEdit v-else class="margin-top-15 margin-right-15" :formdata="getBase" v-model="formData" :labelWidth="120"></compFormEdit>
        </compWrapper>

		<compWrapper title="仓库发货信息" theme="warning">
			<compFormQuery v-if="type=='query'" class="margin-top-15 margin-right-15" :formdata="getWarehouse" :value="formData" :labelWidth="120"></compFormQuery>
			<compFormEdit v-else class="margin-top-15 margin-right-15" :formdata="getWarehouse" v-model="formData" :labelWidth="120"></compFormEdit>
		</compWrapper>

		<compWrapper title="头程信息" theme="info">
			<compFormQuery v-if="type=='query'" class="margin-top-15 margin-right-15" :formdata="getHeadInfo" :value="formData" :labelWidth="120"></compFormQuery>
			<compFormEdit v-else class="margin-top-15 margin-right-15" :formdata="getHeadInfo" v-model="formData" :labelWidth="120"></compFormEdit>
		</compWrapper>

		<compWrapper title="采购信息" theme="success">
			<compFormQuery v-if="type=='query'" class="margin-top-15 margin-right-15" :formdata="getPurchase" :value="formData" :labelWidth="120"></compFormQuery>
			<compFormEdit v-else class="margin-top-15 margin-right-15" :formdata="getPurchase" v-model="formData" :labelWidth="120"></compFormEdit>
		</compWrapper>

		<compWrapper title="清关信息" theme="warning">
			<compClear></compClear>
		</compWrapper>

		<compWrapper title="图片信息" theme="error">
			<compImage></compImage>
		</compWrapper>

		<compWrapper title="其他信息" theme="info">
			<compOther></compOther>
		</compWrapper>

		<compWrapper title="操作历史" theme="gray" v-if="type=='query'">
            <compLog :data="stockOpLogList" :columns="logcolumns"></compLog>
        </compWrapper>

		<div class="text-right">
			<vButton theme="primary">保存</vButton>
			<vButton >取消</vButton>
		</div>
    </div>
</template>

<script>

import { mapState, mapGetters } from "vuex";
import compClear from '../compclear';
import compImage from '../compimage';
import compOther from '../compother';
// 清关信息弹框
import addClear from '../addclear';

export default {
    props:['activeids','querytype'],
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compClear,
		compImage,
		compOther,
    },
    data(){
        return {
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            formData: {
				orderOnlyShow:0,
				danwei:0,
			},
			showquery : this.type == 'query' || this.type == 'edit'
        }
    },
    created(){
        if(this.activeids){
            this.id = this.activeids
            this.type = this.querytype
        }else{
            this.id = this.id
            this.type = this.type
        }
        this.getDetail()
    },
    computed:{
        ...mapState('boss', ['products']),
        getBase(){
            
            return [
				// 1
                {
					label: "品名（英文）",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
                },
                {
					label: "品名（中文）",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
                },
				// 2
                {
					label: "项目",
					key: "lineId",
					tag: "vSelect",
					query: this.showquery,
					options: this.products.map((item) => {
						return {
							value: item.id,
							label: item.name
						}
					}),
					props: {
						filterable: true,
					}
                },
                {
					label: "ERPSKU",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
                },
				// 3
                {
					label: "品类",
					key: "orderNo",
					required: false,
					query: this.showquery,
					props: {
                        placeholder:"自动生成管理码"
					}
                },
                {
					label: "工厂编码",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
                },
				// 4
                {
					label: "是否季节性",
					key: "source",
					tag: "vRadio",
					required: false,
					show: this.type != 'query',
					valueText: this.formData.orderOnlyShow == '0' ? '是' : '否',
					props: {
						strict: false,
					},
					options: [{
						trueValue: '0',
						label: '是'
					}, {
						trueValue: '1',
						label: '否'
					}],
                },
                {
					label: "是否季节性",
					key: "source",
					show: this.type == 'query',
					valueText: this.formData.source == '0' ? '是' : '否'
                },
                {
                    label: "季节性销售周期",
                    tag: 'vDatepicker',
                    key: 'beginSalesDate',
                    query:this.showtip,
                    required:false,
                    props:{
                        format:'yy-mm ~ yy-mm',
                        confirm:false,
                    },
                },
				//5	 
                {
					label: "补货状态",
					key: "lineId",
					tag: "vSelect",
					query: this.showquery,
					options: [
                        {value:0, label:'正常补货'},
                        {value:1, label:'不再补货'}
                    ],
					props: {
						filterable: true,
					}
                },
                {
					label: "EAN",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
                },
				// 6
                {
					label: "品牌",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
                },
                {
					label: "UPC",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
					formItem:{
						tip: !this.showquery ? '' : '<div class="color-error">EAN码是国际物品编码协会制定的一种商品用条码，通用于全世界</div>',
					}
                },
				// 7
                {
					label: "产品类型",
					key: "lineId",
					tag: "vSelect",
					query: this.showquery,
					options: [
                        {value:0, label:'成品'},
                        {value:1, label:'配件'},
                        {value:2, label:'耗材'}
                    ],
					props: {
						filterable: true,
					}
                },
                {
					label: "最小销售单位",
					key: "lineId",
					tag: "vSelect",
					query: this.showquery,
					options: [
                        {value:0, label:'件-Pcs'},
                        {value:1, label:'不再补货'}
                    ],
					props: {
						filterable: true,
					}
                },
				// 8
                {
					label: "是否计算成本",
					key: "source",
					tag: "vRadio",
					required: false,
					show: this.type != 'query',
					valueText: this.formData.orderOnlyShow == '0' ? '是' : '否',
					props: {
						strict: false,
					},
					options: [{
						trueValue: '0',
						label: '是'
					}, {
						trueValue: '1',
						label: '否'
					}],
                },
                {
					label: "是否计算成本",
					key: "source",
					show: this.type == 'query',
					valueText: this.formData.source == '0' ? '是' : '否'
                },
                {
					label: "FOB(USD",
					key: "orderEmail",
					tag: "vInput",
					query: this.showquery,
                },
				// 9
                {
					label: "单品外包装尺寸",
                    tag: "div",
                    span:3,
					query: this.showquery,
                },
                {
                    labelWidth:0,
                    key: "orderEmail",
                    span:5,
					tag: "vInput",
                    query: this.showquery,
                    style:"padding-right:20px",
                    props:{
                        placeholder:"Length"
                    }
                },
                {
                    labelWidth:0,
                    key: "orderEmail",
                    span:5,
					tag: "vInput",
                    query: this.showquery,
                    style:"padding-right:20px",
                    props:{
                        placeholder:"Width",
                        
                    }
                },
                {
                    labelWidth:0,
                    key: "orderEmail",
                    span:5,
					tag: "vInput",
                    query: this.showquery,
                    style:"padding-right:20px",
                    props:{
                        placeholder:"Height"
                    }
                },
                {
					labelWidth:0,
					key: "danwei",
                    tag: "vSelect",
                    span:5,
					query: this.showquery,
					options: [
                        {value:0, label:'cm'},
                        {value:1, label:'inch'},
                    ],
					props: {
						filterable: true,
					}
				},
				// 10
				{
					label: "产品毛重",
                    tag: "div",
                    span:3,
					query: this.showquery,
				},
				{
                    labelWidth:0,
                    key: "orderEmail",
                    span:5,
					tag: "vInput",
                    query: this.showquery,
                    style:"padding-right:20px",
                    props:{
                        placeholder:"Height"
                    }
                },
                {
					labelWidth:0,
					key: "danwei",
                    tag: "vSelect",
					span:5,
					style:"padding-right:20px",
					query: this.showquery,
					options: [
                        {value:0, label:'g'},
						{value:1, label:'oz'},
						{value:1, label:'lb'},
                    ],
					props: {
						filterable: true,
					}
				},

            ]
		},
		getWarehouse(){
			return [
				// 1
				{
					label: "是否加运输包装",
					key: "source",
					tag: "vRadio",
					required: false,
					show: this.type != 'query',
					valueText: this.formData.orderOnlyShow == '0' ? '是' : '否',
					props: {
						strict: false,
					},
					options: [{
						trueValue: '0',
						label: '是'
					}, {
						trueValue: '1',
						label: '否'
					}],
					formItem:{
						tip: !this.showquery ? '' : '<div class="color-error">（加运输包装即需要repack）</div>',
					}
                },
                {
					label: "是否加运输包装",
					key: "source",
					show: this.type == 'query',
					valueText: this.formData.source == '0' ? '是' : '否'
				},
				// 2
				{
					label: "是否需要签收服务",
					key: "source",
					tag: "vRadio",
					required: false,
					show: this.type != 'query',
					valueText: this.formData.orderOnlyShow == '0' ? '是' : '否',
					props: {
						strict: false,
					},
					options: [{
						trueValue: '0',
						label: '是'
					}, {
						trueValue: '1',
						label: '否'
					}],
					formItem:{
						tip: !this.showquery ? '' : '<div class="color-error">（签收服务的资费请咨询客服）</div>',
					}
                },
                {
					label: "是否需要签收服务",
					key: "source",
					show: this.type == 'query',
					valueText: this.formData.source == '0' ? '是' : '否'
				},
				// 3
				{
					label: "快递保价",
					key: "source",
					tag: "vRadio",
					required: false,
					show: this.type != 'query',
					valueText: this.formData.orderOnlyShow == '0' ? '是' : '否',
					props: {
						strict: false,
					},
					options: [{
						trueValue: '0',
						label: '是'
					}, {
						trueValue: '1',
						label: '否'
					}],
					formItem:{
						tip: !this.showquery ? '' : '<div class="color-error">（必须符合FedEx承运范围，具体资费咨询客服）</div>',
					}
                },
                {
					label: "快递保价",
					key: "source",
					show: this.type == 'query',
					valueText: this.formData.source == '0' ? '是' : '否'
				},
				// 4
				{
					label: "货值上浮率（%）",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
					formItem:{
						tip: !this.showquery ? '' : '<div class="color-error">（总货值=FOB*（1+货值上浮率））</div>',
					}
				},
				// 5
				{
					label: "保质期控制",
					key: "source",
					tag: "vRadio",
					required: false,
					show: this.type != 'query',
					valueText: this.formData.orderOnlyShow == '0' ? '是' : '否',
					props: {
						strict: false,
					},
					options: [{
						trueValue: '0',
						label: '是'
					}, {
						trueValue: '1',
						label: '否'
					}],
                },
                {
					label: "保质期控制",
					key: "source",
					show: this.type == 'query',
					valueText: this.formData.source == '0' ? '是' : '否'
				},
				// 6
				{
					label: "保质期",
					key: "orderEmail",
					tag: "vInput",
					span:8,
					required: false,
					query: this.showquery,
				},
				{
					labelWidth:0,
					key: "danwei",
                    tag: "vSelect",
					span:4,
					style:"padding-right:20px",
					query: this.showquery,
					options: [
                        {value:0, label:'天'},
						{value:1, label:'月'},
						{value:1, label:'年'},
                    ],
					props: {
						filterable: true,
					}
				},
				// 7
				{
					label: "单包装销售件数",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
					formItem:{
						tip: !this.showquery ? '' : '<div class="color-error">（最小配送单位内的商品数量，即消费者收到的最小包装、邮购单位）</div>',
					}
				},
			]
		},
		getHeadInfo(){
			return [
				// 1
				{
					label: "单品外包装尺寸",
                    tag: "div",
                    span:3,
					query: this.showquery,
                },
                {
                    labelWidth:0,
                    key: "orderEmail",
                    span:5,
					tag: "vInput",
                    query: this.showquery,
                    style:"padding-right:20px",
                    props:{
                        placeholder:"Length"
                    }
                },
                {
                    labelWidth:0,
                    key: "orderEmail",
                    span:5,
					tag: "vInput",
                    query: this.showquery,
                    style:"padding-right:20px",
                    props:{
                        placeholder:"Width",
                        
                    }
                },
                {
                    labelWidth:0,
                    key: "orderEmail",
                    span:5,
					tag: "vInput",
                    query: this.showquery,
                    style:"padding-right:20px",
                    props:{
                        placeholder:"Height"
                    }
                },
                {
					labelWidth:0,
					key: "danwei",
                    tag: "vSelect",
                    span:5,
					query: this.showquery,
					options: [
                        {value:0, label:'cm'},
                        {value:1, label:'inch'},
                    ],
					props: {
						filterable: true,
					}
				},
				// 2
				{
					label: "外箱体积",
					tag:'vInput',
					key: "ruleCostFormula",
					children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">CBM</span>
					},
					show:this.type!='query'
				},
				// 3
				{
					label: "单箱毛重",
					tag: "vInput",
					key: "ruleCostFormula",
                    span:8,
					query: this.showquery,
				},
				{
					labelWidth:0,
					key: "danwei",
                    tag: "vSelect",
                    span:4,
					query: this.showquery,
					options: [
                        {value:0, label:'g'},
                        {value:1, label:'oz'},
                    ],
					props: {
						filterable: true,
					}
				},
				// 4
				{
					label: "装箱入数",
					tag:'vInput',
					key: "ruleCostFormula",
					span:24,
					show:this.type!='query',
					formItem: {
						style: "width:50%"
					},
				},
				// 5,6
				{
					label: "20尺柜装箱量",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
					formItem:{
						tip: !this.showquery ? '' : '<div class="color-error">（默认自动计算，20尺柜体积/单品体积）</div>',
					}
				},
				{
					label: "45尺柜装箱量",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
					formItem:{
						tip: !this.showquery ? '' : '<div class="color-error">（默认自动计算，45尺柜体积/单品体积）</div>',
					}
				},

				// 7,8
				{
					label: "40尺平柜装箱量",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
					formItem:{
						tip: !this.showquery ? '' : '<div class="color-error">（默认自动计算，40尺平柜体积/单品体积）</div>',
					}
				},
				{
					label: "40尺高柜装箱量",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
					formItem:{
						tip: !this.showquery ? '' : '<div class="color-error">（默认自动计算，40尺高柜体积/单品体积）</div>',
					}
				},
			]
		},
		getPurchase(){
			return [
				{
					label: "生产提前期(天)",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
				},
				{
					label: "物流提前期(天)",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
				},
				{
					label: "最小起订量",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
				},
				{
					label: "补货周期(天)",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
				},
				{
					label: "安全库存天数",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
				},
			]
		}
    },
    methods:{
        getDetail(){
            if(this.type=='add') return


		},
    }
}
</script>